import { isToday, isPast } from 'date-fns';
import type { Bill } from '@/types/financial';

export type ComputedBillStatus = 'PAID' | 'RECEIVED' | 'DUE_TODAY' | 'OVERDUE' | 'PENDING';

export const BILL_STATUS_LABELS: Record<ComputedBillStatus, string> = {
  PAID: 'Pago',
  RECEIVED: 'Recebido',
  DUE_TODAY: 'Vence hoje',
  OVERDUE: 'Vencido',
  PENDING: 'Pendente',
};

export const BILL_STATUS_COLORS: Record<ComputedBillStatus, string> = {
  PAID: 'bg-green-500',
  RECEIVED: 'bg-green-500',
  DUE_TODAY: 'bg-yellow-500',
  OVERDUE: 'bg-red-500',
  PENDING: 'bg-yellow-500',
};

export function computeBillStatus(bill: Bill): ComputedBillStatus {
  const billDate = new Date(bill.date);

  if (bill.paid) {
    return bill.type === 'PAYABLE' ? 'PAID' : 'RECEIVED';
  }

  if (isToday(billDate)) {
    return 'DUE_TODAY';
  }

  if (isPast(billDate)) {
    return 'OVERDUE';
  }

  return 'PENDING';
}

export function mapBill(bill: Bill): Bill & { computed_status: ComputedBillStatus } {
  return {
    ...bill,
    computed_status: computeBillStatus(bill),
  };
}
